<template>
    <div class="games-general-settings">
        <!-- game categories -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Game categories</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <draggable :list="categories">
                            <div class="menu-item" v-for="category in categories" :key="category.name">
                                <span class="icon is-small">
                                    <i class="fas fa-grip-vertical"></i>
                                </span>
                                {{ category.name }}
                                <input v-model="category.enabled" type="checkbox" class="checkbox" />
                            </div>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>

        <!-- game providers -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Game providers</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <draggable :list="providers">
                            <div class="menu-item" v-for="provider in providers" :key="provider.name">
                                <span class="icon is-small">
                                    <i class="fas fa-grip-vertical"></i>
                                </span>
                                {{ provider.name }}
                                <input v-model="provider.enabled" type="checkbox" class="checkbox" />
                            </div>
                        </draggable>
                    </div>
                </div>
            </div>
        </div>

        <!-- gambling -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Gambling</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.gambling" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- skill game -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Skill game</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.skillGame" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- use entries -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Use entries</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <p class="control">
                        <label class="checkbox">
                            <input v-model="settings.useEntries" type="checkbox" />
                        </label>
                    </p>
                </div>
            </div>
        </div>

        <!-- sweepstakes mode -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Sweepstakes mode</label>
            </div>
            <div class="field-body">
                <div class="field">
                    <div class="control">
                        <div class="select">
                            <select v-model="settings.sweepstakesMode">
                                <option :value="null">None</option>
                                <option value="sb">Single balance</option>
                                <option value="db">Double balance</option>
                            </select>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- currencies settings -->
        <div class="field is-horizontal">
            <div class="field-label is-normal">
                <label class="label">Add currency settings</label>
            </div>
            <div class="field-body">
                <div class="field has-addons">
                    <div class="control">
                        <div class="select">
                            <select v-model="newCurrency">
                                <option v-for="currency in newCurrencies" :key="currency.id" :value="currency.id">{{ currency.id }}</option>
                            </select>
                        </div>
                    </div>
                    <div class="control">
                        <a class="button is-success" @click="addNewCurrencyToSettings()">Add</a>
                    </div>
                </div>
            </div>
        </div>
        <table class="table is-size-7">
            <tr>
                <th>Currency</th>
                <th>Entry symbol</th>
                <th>Entry cost</th>
                <th></th>
            </tr>
            <tr v-for="curSet in settings.currencySettings" :key="curSet.currency">
                <td>{{ curSet.currency }}</td>
                <td>
                    <input v-model="curSet.entrySymbol" type="text" class="input is-small currency-settings-input" />
                </td>
                <td>
                    <input v-model="curSet.entryCost" type="number" class="input is-small currency-settings-input" />
                </td>
                <td>
                    <a @click="removeCurrencyFromSettings(curSet.currency)" class="button is-danger is-small">del</a>
                </td>
            </tr>
        </table>

        <!-- save -->
        <div class="field is-horizontal">
            <div class="field-label"></div>
            <div class="field-body">
                <div class="field is-grouped">
                    <div class="control">
                        <button @click="save()" class="button is-primary">Save</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import state from '../../state';

import Draggable from 'vuedraggable';

export default {
    name: 'games-general-settings',
    components: { Draggable },
    props: {
        gamesSettings: {
            type: Object,
            required: true
        },
        saveGamesSettings: {
            type: Function,
            required: true
        }
    },
    data() {
        return {
            settings: this.gamesSettings,
            categories: [],
            allCategories: [
                'slots',
                'video-games',
                'virtual-sports',
                'fast',
                'crash',
                'lotto',
                'races',
                'spin-to-win',
                'virtuals',
                'sport',
                'live-casino',
                'covid',
                'softgamings',
                'skillgames',
                'multiplayer',
                'xgames',
                'vegas',
                'poker',
                'scratch-games',
                'tv-games',
                'table-games',
                'double-chance-lotto',
                'shooting',
                'toto'
            ],
            providers: [],
            allProviders: [
                'redpipe',
                'flg',
                'hdraces',
                'bk',
                'tvbet',
                'covid',
                'softgamings',
                'mascot',
                'aviatrix',
                'galaxsys',
                'smartsoft',
                'vegas',
                'boldplay',
                'doublechancelotto',
                'toto',
                'betconstruct',
                'baas'
            ],
            newCurrency: null
        };
    },
    computed: {
        currencies() {
            return state.currencies.get();
        },
        newCurrencies() {
            return this.currencies.filter(c => !this.settings.currencySettings.find(cs => cs.currency == c.id));
        }
    },
    mounted() {
        this.load();
    },
    methods: {
        load() {
            // categories
            this.categories = [];
            this.settings.gameCategories.forEach(category => {
                let exists = this.allCategories.find(c => c === category);
                if (exists) {
                    this.categories.push({
                        name: category,
                        enabled: true
                    });
                }
            });
            this.allCategories.forEach(category => {
                let exists = this.categories.find(c => c.name === category);
                if (!exists) {
                    this.categories.push({ name: category, enabled: false });
                }
            });

            // providers
            this.providers = [];
            this.settings.gameProviders.forEach(provider => {
                let exists = this.allProviders.find(p => p === provider);
                if (exists) {
                    this.providers.push({
                        name: provider,
                        enabled: true
                    });
                }
            });
            this.allProviders.forEach(provider => {
                let exists = this.providers.find(p => p.name === provider);
                if (!exists) {
                    this.providers.push({ name: provider, enabled: false });
                }
            });
        },
        addNewCurrencyToSettings() {
            if (!this.newCurrency) return;
            if (this.settings.currencySettings.find(gs => gs.currency == this.newCurrency)) return;
            this.settings.currencySettings.push({
                currency: this.newCurrency,
                entrySymbol: '',
                entryCost: 1
            });
            this.newCurrency = null;
        },
        removeCurrencyFromSettings(currency) {
            let curIndex = this.settings.currencySettings.findIndex(gs => gs.currency == currency);
            if (curIndex >= 0) this.settings.currencySettings.splice(curIndex, 1);
        },
        async save() {
            // set categories
            this.settings.gameCategories = [];
            this.categories.forEach(c => {
                if (c.enabled) {
                    this.settings.gameCategories.push(c.name);
                }
            });

            // set providers
            this.settings.gameProviders = [];
            this.providers.forEach(p => {
                if (p.enabled) {
                    this.settings.gameProviders.push(p.name);
                }
            });

            this.saveGamesSettings(this.settings);
        }
    }
};
</script>

<style lang="scss">
.games-general-settings {
    .menu-item {
        margin-bottom: 0.32rem;
        padding: 0.4rem 0.8rem;
        width: 240px;
        border: 1px solid #666;
        border-radius: 0.2rem;
        background-color: #333;

        .icon {
            margin-right: 0.2rem;
        }

        .checkbox {
            float: right;
        }
    }

    .currency-settings-input {
        max-width: 180px;
    }
}
</style>



// WEBPACK FOOTER //
// front/src/components/common/games-general-settings.vue